import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { LoadingComponent } from '../loading/loading.component';
import { MatRippleModule } from '@angular/material/core';

@Component({
  selector: 'app-double-icon-button',
  imports: [CommonModule, MatIconModule, LoadingComponent, MatRippleModule],
  templateUrl: './double-icon-button.component.html',
})
export class DoubleIconButtonComponent {
  disabled = input(false);
  loading = input(false);
  leadingIconSM = input<string>();
  leadingIconXL = input<string>();
  leadingIconColor = input<string>('text-grey');
  leadingIconSize = input<string>('text-sm');
  trailingIconSM = input<string>();
  trailingIconXL = input<string>();
  trailingIconColor = input<string>('text-grey');
  trailingIconSize = input<string>('text-sm');

  buttonClicked = output<void>();

  handleClick(): void {
    if (this.loading() || this.disabled()) {
      return;
    }
    this.buttonClicked.emit();
  }
}
